import React, { useState, useEffect } from 'react';
import { Form, Button, Spinner, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { forgotPassword, clearError, resetAuthStatus } from '../../store/slices/authSlice';
import AuthLayout from './AuthLayout';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error, success } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(resetAuthStatus());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      // Passing email to VerifyOTP page via state
      navigate('/verify-otp', { state: { email, type: 'forgot_password' } });
      dispatch(resetAuthStatus());
    }
  }, [success, navigate, email, dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(forgotPassword({ email }));
  };

  const isFormValid = email.length > 0;

  return (
    <AuthLayout
      title="Forgot Password?"
      subtitle="Enter your email to receive a password reset code"
    >
      {error && <Alert variant="danger" dismissible onClose={() => dispatch(clearError())}>{error}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-4" controlId="forgotEmail">
          <Form.Label>Email Address</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />
          <Form.Text className="d-block text-muted mt-2">
            We'll send a 6-digit OTP code to verify your identity.
          </Form.Text>
        </Form.Group>

        <div className="d-flex flex-column gap-3">
          <Button
            variant="primary"
            type="submit"
            className="w-100 btn-custom d-flex align-items-center justify-content-center gap-2"
            disabled={!isFormValid || loading}
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" />
                Sending OTP...
              </>
            ) : 'Send OTP'}
          </Button>
          <Link to="/login" className="btn btn-outline-secondary btn-custom d-flex align-items-center justify-content-center gap-2">
            <i className="bi bi-arrow-left"></i> Back to Login
          </Link>
        </div>
      </Form>
    </AuthLayout>
  );
};

export default ForgotPassword;
